import { render, staticRenderFns } from "./JQuotaProgress.vue?vue&type=template&id=4ef20594&scoped=true&"
import script from "./JQuotaProgress.vue?vue&type=script&lang=ts&"
export * from "./JQuotaProgress.vue?vue&type=script&lang=ts&"
import style0 from "./JQuotaProgress.vue?vue&type=style&index=0&id=4ef20594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef20594",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
